import { Dispatch, SetStateAction, useState } from "react";

import { CombinedPart } from "./combinePartsForPricing";
import { PricingOption } from "./getFlatPricingOptions";

export type PriceSelectEntry = {
  combinedPart: CombinedPart;
  pricingOption: PricingOption;
};

interface PriceSelectStateHook {
  (initialState: PriceSelectEntry[]): [
    PriceSelectEntry[],
    Dispatch<SetStateAction<PriceSelectEntry[]>>
  ];
}

export const usePriceSelectState: PriceSelectStateHook = useState;
